import { useEffect, useRef } from 'react';

/**
 * Custom hook that scrolls to the error element when an error string
 * changes from empty to non-empty (i.e. a new error appears).
 *
 * Usage:
 *   const errorRef = useScrollToError(error);
 *   ...
 *   {error && <div ref={errorRef} className="error">{error}</div>}
 */
export function useScrollToError(error: string) {
  const errorRef = useRef<HTMLDivElement>(null);
  const prevError = useRef<string>('');

  useEffect(() => {
    if (error && error !== prevError.current && errorRef.current) {
      errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    prevError.current = error;
  }, [error]);

  return errorRef;
}
